import { useTranslation } from 'react-i18next';
import './UploadButtonMessage.css';

function UploadButtonMessage({ filename, onDelete, index, width = '20%', showDelete = true }) {
    const { t: tCommon } = useTranslation('common');
    return (
        <div className='file-item-message' key={index}>
            {(() => {
                if (!filename) {
                    return null;
                }
                const ext = filename.split('.').pop().toLowerCase();

                if (ext === 'pdf') {
                    return <img src="/imagens/pdf.svg" alt={tCommon("pdfFile")} />;
                } else if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext)) {
                    return <img src="/imagens/image.svg" alt={tCommon("imageFile")} />;
                } else if (['xls', 'xlsx'].includes(ext)) {
                    return <img src="/imagens/xls.svg" alt={tCommon("excelFile")} />;
                } else {
                    return <img src="/imagens/file.svg" alt={tCommon("genericFile")} />;
                }
            })()}
            <div className="file-name-message">{filename}</div>
        </div>
    );

}

export default UploadButtonMessage;